import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

// Schema kiểm tra tính hợp lệ
const schema = yup.object().shape({
  fullName: yup.string().required("Họ và tên là bắt buộc."),
  email: yup.string().email("Email không hợp lệ.").required("Email là bắt buộc."),
  password: yup
    .string()
    .min(6, "Mật khẩu phải có ít nhất 6 ký tự.")
    .required("Mật khẩu là bắt buộc."),
  age: yup
    .number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue.trim() === "" ? null : value
    )
    .min(0, "Tuổi không được nhỏ hơn 0.")
    .max(150, "Tuổi không hợp lệ."),
  hometown: yup.string().nullable(),
  avatar: yup.mixed().nullable(),
});


const RegisterForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    console.log("Dữ liệu form:", data);
    alert("Đăng ký thành công!");
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2>Đăng ký</h2>
      
      <div>
        <label>Họ và tên:</label>
        <input {...register("fullName")} placeholder="Nhập họ và tên" />
        <p>{errors.fullName?.message}</p>
      </div>

      <div>
        <label>Email:</label>
        <input {...register("email")} placeholder="Nhập email" />
        <p>{errors.email?.message}</p>
      </div>

      <div>
        <label>Mật khẩu:</label>
        <input {...register("password")} type="password" placeholder="Nhập mật khẩu" />
        <p>{errors.password?.message}</p>
      </div>

      <div>
        <label>Tuổi (tùy chọn):</label>
        <input {...register("age")} type="number" placeholder="Nhập tuổi" />
        <p>{errors.age?.message}</p>
      </div>

      <div>
        <label>Quê quán (tùy chọn):</label>
        <input {...register("hometown")} placeholder="Nhập quê quán" />
      </div>

      <div>
        <label>Ảnh đại diện (tùy chọn):</label>
        <input {...register("avatar")} type="file" accept="image/*" />
      </div>

      <button type="submit">Đăng ký</button>
    </form>
  );
};

export default RegisterForm;
